import React from 'react';
import { Box, Typography, Link, Container, Grid } from '@mui/material';
 // Import Footer component

const Footer = () => {
  return (
    <Box sx={{ bgcolor: '#183B4E', color: 'white', py: 4, mt: 4 }}>
      <Container>
        <Grid container spacing={4}>

          {/* Left: Contact Us */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Contact Us
            </Typography>
            <Typography>Email: contact@company.com</Typography>
            <Typography>Phone: +91 123 456 7890</Typography>
            <Typography>Address: 123 Street, City, India</Typography>
          </Grid>

          {/* Center: Page Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Page Links
            </Typography>
            <Link href="/" color="inherit" underline="hover">Home</Link><br />
            <Link href="/about" color="inherit" underline="hover">About Us</Link><br />
            <Link href="/services" color="inherit" underline="hover">Services</Link><br />
            <Link href="/contact" color="inherit" underline="hover">Contact</Link>
          </Grid>

          {/* Right: Useful Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Useful Links
            </Typography>
            <Link href="/faq" color="inherit" underline="hover">FAQ</Link><br />
            <Link href="/privacy" color="inherit" underline="hover">Privacy Policy</Link><br />
            <Link href="/terms" color="inherit" underline="hover">Terms of Service</Link><br />
            <Link href="/support" color="inherit" underline="hover">Support</Link>
          </Grid>

        </Grid>

        <Typography variant="body2" align="center" sx={{ mt: 3 }}>
          © {new Date().getFullYear()} Your Company. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
